import React, { useRef, useEffect, useState } from 'react';
import './styleWeekView.css';

const WeekView = (props) => {
    const headerRef = useRef(null);

    const dateString = props.props.date.toString();
    const dateParts = dateString.split(' ');
    const day = dateParts[0];
    const dateSplit = dateString.split(" ");
    const calendarDay = dateSplit[2].toString();
    const newDate = new Date();
    const listDate = newDate.toString().split(" ");
    const getToday = listDate[2].toString();
    const currentMonth = dateSplit[1].toString() + dateSplit[3].toString();
    const todayMonth = listDate[1].toString() + listDate[3].toString();
    const isToday = calendarDay === getToday && currentMonth === todayMonth;
    const [state, setState] = useState({
        'Mon': 0,
        'Tue': 1,
        'Wed': 2,
        'Thu': 3,
        'Fri': 4,
        'Sat': 5,
        'Sun': 6
    });
    useEffect(() => {
        var elements = document.querySelectorAll('.rbc-button-link');
        if (elements) {
            elements.forEach(function (element) {
                element.disabled = true
            });
        }
        var elements = document.querySelectorAll('.rbc-header');
        elements[6].setAttribute("style", "flex:0 0")
        elements[state[listDate[0]]].setAttribute("style", "min-width:22%")
    })
    const handleCheck = (e) => {
        e.stopPropagation();
        console.log(e.target.value)
    }
    const handleDayLength = (e) => {
        console.log(e)
        var elements = document.querySelectorAll('.rbc-header');
        if (elements) {
            elements.forEach(function (element) {
                element.setAttribute("style", "min-width:unset")
            });
        }
        elements[state[e]].setAttribute("style", "min-width:22%")
    }
    if (day === 'Sun') {
        return (
            <div className='weekView'>
                <div className='weekView-container'>
                    {day} <span>{dateParts[2]}</span>
                </div>
                <div className='weekView-Content' style={{ background: '#263238' }}>
                </div>
            </div>
        );
    }
    return (
        <div className='weekView'>
            <style>
                {`.rbc-time-header {
            height: 100%;
            }
            .rbc-time-header-content {
            height: 100%;
            }
            .rbc-time-view .rbc-row {
            height: 100%;
            .rbc-button-link {
                width:100%;
            }
            .rbc-time-header-content .rbc-header {
                padding: 0 0px;
            }
            .rbc-button-link {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
            }
            `
                }
            </style>
            <div className='weekView-container'>
                <div className='day-text-containt'>
                    {day} <span>{dateParts[2]}</span>
                </div>
                <div className='progressDiv' style={{ background: isToday ? "#F2F2F2" : null }}>
                    <div className='progressBar' style={{ width: "65%", background: isToday ? '#21CD85' : null }} ></div>
                </div>
            </div>
            <div className='weekView-Content'>
                <div className='week-faint-div'></div>
                <div className='week-assigned-task'>
                    <div className='week-task'>
                        <input type='checkbox' onChange={(e) => {
                            handleCheck(e)
                        }} />
                        <div className='task' onClick={handleDayLength} title="Coffee app edits">Coffee app edits</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WeekView;
